import {
    ListenerMiddleware,
    registerPredicateEffect,
} from 'store/listenerMiddleware';
import { buildEstimatedTradeCostComparisonWidgetComponentSlice } from 'widgets/estimatedTradeCost/widget-comparison/store/componentSlice';
import { selectEstimatedTradeCostComparisonWidgetsState } from 'widgets/estimatedTradeCost/widget-comparison/store/selectors';
import { buildClearComponentStateOnSelectedOrderChangedEffect } from 'widgets/estimatedTradeCost/widget/store/effects-shared';

const {
    actions,
    selectors: { selectComponentState },
} = buildEstimatedTradeCostComparisonWidgetComponentSlice();

const clearComponentStateOnSelectedOrderChangedEffect =
    buildClearComponentStateOnSelectedOrderChangedEffect(
        'estimatedTradeCostComparisonWidget',
        selectEstimatedTradeCostComparisonWidgetsState,
        selectComponentState,
        actions.createUpdateComponentAction
    );

export function registerEstimatedTradeCostComparisonEffects(
    middleware: ListenerMiddleware
) {
    registerPredicateEffect(
        middleware,
        clearComponentStateOnSelectedOrderChangedEffect
    );
}
